import { SET_EDIT, SET_UNEDIT } from '../../constant';

const SetEdit = () => ({
  type: SET_EDIT,
});

const SetUnEdit = () => ({
  type: SET_UNEDIT,
});

export { SetEdit, SetUnEdit };
